/**
 * Task D: customer profile upgrade, membership & points, POS package redemption (可用套餐 / 核销套餐),
 * 套餐与储值 centre and WhatsApp broadcasts (群发). One row per key: [key, English, 中文, Bahasa Melayu].
 * Spread into en/zh/ms (keys are MessageKeys) and registered in ../modules.ts for the completeness test.
 */
const ROWS = [
  ["nav.memberCentre", "Packages & credit", "套餐与储值", "Pakej & kredit"],
  ["nav.campaigns", "Broadcasts", "群发消息", "Siaran"],
  ["nav.membership", "Membership & points", "会员与积分", "Keahlian & mata"],
  ["cust.tab.membership", "Points & vouchers", "积分与优惠券", "Mata & baucar"],
  ["mb.birthdayMonth", "Birthday this month", "本月生日", "Hari lahir bulan ini"],
  ["mb.allergy", "Allergy / medical", "过敏 / 医疗提示", "Alahan / perubatan"],
  ["mb.allergyWarn", "Allergy / medical: {text}", "过敏 / 医疗提示：{text}", "Alahan / perubatan: {text}"],
  ["mb.allergyPh", "e.g. allergic to certain oils or dyes, pregnant, sensitive skin", "例如：对某些精油或染剂过敏、怀孕、皮肤敏感", "cth. alah minyak atau pewarna tertentu, hamil, kulit sensitif"],
  ["mb.allergyHelp", "Shown as a warning at checkout and on bookings.", "将在收银和预约时以警示显示。", "Dipaparkan sebagai amaran di kaunter dan pada tempahan."],
  ["mb.gender", "Gender", "性别", "Jantina"],
  ["mb.gender.female", "Female", "女", "Perempuan"],
  ["mb.gender.male", "Male", "男", "Lelaki"],
  ["mb.gender.other", "Other", "其他", "Lain-lain"],
  ["mb.gender.undisclosed", "Prefer not to say", "不愿透露", "Tidak mahu nyatakan"],
  ["mb.address", "Address", "地址", "Alamat"],
  ["mb.source", "Source", "来源", "Sumber"],
  ["mb.source.walk_in", "Walk-in", "到店", "Datang terus"],
  ["mb.source.online", "Online booking", "线上预约", "Tempahan dalam talian"],
  ["mb.source.referral", "Referral", "转介绍", "Rujukan"],
  ["mb.source.social", "Social media", "社交媒体", "Media sosial"],
  ["mb.source.other", "Other", "其他", "Lain-lain"],
  ["mb.day", "Day", "日", "Hari"],
  ["mb.month", "Month", "月", "Bulan"],
  ["mb.yearOpt", "Year (optional)", "年（可选）", "Tahun (pilihan)"],
  ["mb.birthdayHelp", "Day and month are enough for birthday rewards.", "填写日和月即可享受生日福利。", "Hari dan bulan sudah cukup untuk ganjaran hari lahir."],
  ["mb.memberNo", "Member no.", "会员卡号", "No. ahli"],
  ["mb.emailMarketing", "Marketing e-mails", "营销邮件", "E-mel pemasaran"],
  ["mb.emailMarketingHelp", "offers by e-mail (separate from WhatsApp)", "通过邮件接收优惠（与 WhatsApp 分开）", "tawaran melalui e-mel (berasingan daripada WhatsApp)"],
  ["mb.optedOut", "Replied STOP on {date}", "已于 {date} 回复 STOP 退订", "Membalas STOP pada {date}"],
  ["mb.tier.none", "No tier yet", "暂无等级", "Belum ada tahap"],
  ["mb.tier.top", "Top level reached", "已达最高等级", "Tahap tertinggi dicapai"],
  ["mb.tier.toGoSpend", "{amount} more to {next}", "再消费 {amount} 升级为 {next}", "{amount} lagi ke {next}"],
  ["mb.tier.toGoVisits", "{n} more visits to {next}", "再到店 {n} 次升级为 {next}", "{n} lawatan lagi ke {next}"],
  ["mb.tier.window", "Last {n} months: {amount} · {visits} visits", "近 {n} 个月：消费 {amount} · 到店 {visits} 次", "{n} bulan lepas: {amount} · {visits} lawatan"],
  ["mb.tier.benefits", "Benefits", "会员权益", "Faedah"],
  ["mb.tier.disc", "Services {svc}% · Retail {prod}% · Packages {pkg}% off", "服务 {svc}% · 零售 {prod}% · 套餐 {pkg}% 折扣", "Servis {svc}% · Runcit {prod}% · Pakej {pkg}% diskaun"],
  ["mb.tier.mult", "Points ×{x}", "积分 ×{x}", "Mata ×{x}"],
  ["mb.pk.summary", "{n} active · {sessions} sessions left", "{n} 个有效 · 剩 {sessions} 次", "{n} aktif · {sessions} sesi berbaki"],
  ["mb.pk.value", "{amount} value left", "剩余金额 {amount}", "Baki nilai {amount}"],
  ["mb.pk.nearest", "Nearest expiry {date}", "最近到期 {date}", "Tamat terdekat {date}"],
  ["mb.pk.none", "No active packages", "没有有效套餐", "Tiada pakej aktif"],
  ["mb.credit.principal", "Principal", "本金", "Pokok"],
  ["mb.credit.bonus", "Bonus", "赠送", "Bonus"],
  ["mb.credit.none", "No credit", "无储值", "Tiada kredit"],
  ["mb.visits.last", "Last visit", "最近到店", "Lawatan terakhir"],
  ["mb.visits.freq", "Visit frequency", "到店频率", "Kekerapan lawatan"],
  ["mb.visits.freqVal", "{n} in 12 months · every ~{days} days", "近 12 个月 {n} 次 · 约每 {days} 天", "{n} dalam 12 bulan · setiap ~{days} hari"],
  ["mb.visits.freqNone", "{n} in 12 months", "近 12 个月 {n} 次", "{n} dalam 12 bulan"],
  ["mb.points", "Points", "积分", "Mata"],
  ["mb.points.balance", "{n} points", "{n} 积分", "{n} mata"],
  ["mb.points.expiring", "{n} expire on {date}", "{n} 积分将于 {date} 到期", "{n} tamat pada {date}"],
  ["mb.points.off", "Points are switched off", "积分未开启", "Mata dimatikan"],
  ["mb.vouchers", "Vouchers", "优惠券", "Baucar"],
  ["mb.voucher.none", "No vouchers", "没有优惠券", "Tiada baucar"],
  ["mb.qa.sale", "New sale", "开单", "Jualan baharu"],
  ["mb.qa.book", "Book", "预约", "Tempah"],
  ["mb.qa.topup", "Top up", "充值", "Tambah nilai"],
  ["mb.qa.package", "Buy package", "购买套餐", "Beli pakej"],
  ["mb.qa.whatsapp", "WhatsApp", "WhatsApp", "WhatsApp"],
  ["mb.notes.add", "Add note", "添加备注", "Tambah nota"],
  ["mb.notes.ph", "Write a note for the team…", "给团队写一条备注…", "Tulis nota untuk pasukan…"],
  ["mb.notes.pin", "Pin to top", "置顶", "Sematkan"],
  ["mb.notes.pinned", "Pinned", "已置顶", "Disematkan"],
  ["mb.notes.legacy", "Profile note", "资料备注", "Nota profil"],
  ["mb.notes.empty", "No notes yet", "暂无备注", "Belum ada nota"],
  ["mb.notes.by", "{name} · {date}", "{name} · {date}", "{name} · {date}"],
  ["mb.tags.manage", "Manage tags", "管理标签", "Urus tag"],
  ["mb.tags.new", "New tag", "新标签", "Tag baharu"],
  ["mb.tags.color", "Colour", "颜色", "Warna"],
  ["mb.tags.count", "{n} customers", "{n} 位顾客", "{n} pelanggan"],
  ["mb.tags.pick", "Tags", "标签", "Tag"],
  ["mb.pl.earn", "Earned", "获得", "Diperoleh"],
  ["mb.pl.redeem", "Used at checkout", "收银抵扣", "Digunakan di kaunter"],
  ["mb.pl.reward", "Reward", "兑换礼品", "Ganjaran"],
  ["mb.pl.expire", "Expired", "过期", "Tamat tempoh"],
  ["mb.pl.adjust", "Adjusted", "调整", "Dilaraskan"],
  ["mb.pl.reverse", "Reversed", "冲回", "Dibalikkan"],
  ["mb.pl.bonus", "Bonus", "赠送", "Bonus"],
  ["mb.points.adjust", "Adjust points", "调整积分", "Laraskan mata"],
  ["mb.points.amount", "Points (+ add / − deduct)", "积分（+ 增加 / − 扣减）", "Mata (+ tambah / − tolak)"],
  ["mb.points.reason", "Reason", "原因", "Sebab"],
  ["mb.points.history", "Points history", "积分记录", "Sejarah mata"],
  ["mb.reward.title", "Rewards", "积分兑换", "Ganjaran"],
  ["mb.reward.redeem", "Redeem", "兑换", "Tebus"],
  ["mb.reward.cost", "{n} points", "{n} 积分", "{n} mata"],
  ["mb.reward.done", "Voucher {code} issued", "已发放优惠券 {code}", "Baucar {code} dikeluarkan"],
  ["mb.v.code", "Code", "券码", "Kod"],
  ["mb.v.fixed", "{amount} off", "减 {amount}", "{amount} diskaun"],
  ["mb.v.percent", "{pct}% off", "{pct}% 折扣", "{pct}% diskaun"],
  ["mb.v.service", "Free {service}", "免费 {service}", "{service} percuma"],
  ["mb.v.minSpend", "min. spend {amount}", "满 {amount} 可用", "belanja min. {amount}"],
  ["mb.v.until", "until {date}", "有效至 {date}", "sehingga {date}"],
  ["mb.v.state.active", "Active", "可用", "Aktif"],
  ["mb.v.state.used", "Used", "已使用", "Digunakan"],
  ["mb.v.state.expired", "Expired", "已过期", "Tamat tempoh"],
  ["mb.v.state.void", "Void", "已作废", "Batal"],
  ["mb.v.issue", "Issue voucher", "发放优惠券", "Keluarkan baucar"],
  ["mb.v.name", "Voucher name", "优惠券名称", "Nama baucar"],
  ["mb.v.kind", "Type", "类型", "Jenis"],
  ["mb.v.kind.fixed", "Amount off", "减免金额", "Potongan amaun"],
  ["mb.v.kind.percent", "Percent off", "折扣百分比", "Potongan peratus"],
  ["mb.v.kind.service", "Free service", "免费服务", "Servis percuma"],
  ["mb.v.value", "Value", "面值", "Nilai"],
  ["mb.v.percentValue", "Percent", "百分比", "Peratus"],
  ["mb.v.serviceLabel", "Service", "服务", "Servis"],
  ["mb.v.validDays", "Valid for (days)", "有效天数", "Sah selama (hari)"],
  ["mb.v.maxUses", "Uses per voucher", "每张可用次数", "Penggunaan setiap baucar"],
  ["mb.v.issued", "{n} vouchers issued", "已发放 {n} 张优惠券", "{n} baucar dikeluarkan"],
  ["mb.v.newCode", "New promo code", "新建优惠码", "Kod promo baharu"],
  ["mb.v.codes", "Promo codes", "优惠码", "Kod promo"],
  ["mb.v.code", "Code", "优惠码", "Kod"],
  ["mb.v.codeAuto", "Leave empty to generate one", "留空则自动生成", "Biarkan kosong untuk jana automatik"],
  ["mb.v.codeCreated", "Promo code {code} created", "已创建优惠码 {code}", "Kod promo {code} dicipta"],
  ["mb.v.perCustomer", "Uses per customer", "每位顾客可用次数", "Penggunaan setiap pelanggan"],
  ["mb.v.shopEnabled", "Usable in the online shop", "可用于网上商城", "Boleh digunakan di kedai dalam talian"],
  ["mb.v.shopEnabledHint", "Customers can enter the code at the online checkout. The use is final only when the order is paid.", "顾客可在网上商城结账时输入此码。订单付款后才算使用。", "Pelanggan boleh masukkan kod semasa pembayaran dalam talian. Penggunaan muktamad hanya apabila pesanan dibayar."],
  ["mb.v.branches", "Only at these branches (none ticked = all)", "仅限这些门店（不勾选＝全部）", "Hanya di cawangan ini (tiada ditanda = semua)"],
  ["mb.v.categories", "Only on these categories (none ticked = everything)", "仅限这些类别（不勾选＝全部）", "Hanya untuk kategori ini (tiada ditanda = semua)"],
  ["mb.v.shop", "Online shop", "网上商城", "Kedai dalam talian"],
  ["mb.v.usage", "{uses}/{max} used", "已用 {uses}/{max}", "{uses}/{max} digunakan"],
  ["mb.v.void", "Void", "作废", "Batalkan"],
  ["mb.v.for", "For {n} customers", "发给 {n} 位顾客", "Untuk {n} pelanggan"],
  ["mb.pos.packages", "Packages {n}", "可用套餐 {n}", "Pakej {n}"],
  ["mb.pos.packagesTitle", "Usable packages", "可用套餐", "Pakej boleh guna"],
  ["mb.pos.left", "{n} left", "剩 {n} 次", "{n} berbaki"],
  ["mb.pos.valueLeft", "{amount} left", "余额 {amount}", "Baki {amount}"],
  ["mb.pos.covers", "Covers: {list}", "适用：{list}", "Meliputi: {list}"],
  ["mb.pos.anyService", "all services", "全部服务", "semua servis"],
  ["mb.pos.useOn", "Use package", "用套餐抵扣", "Guna pakej"],
  ["mb.pos.useOnHint", "{name} · {n} left", "{name} · 剩 {n} 次", "{name} · {n} berbaki"],
  ["mb.pos.addRedeem", "Add & redeem", "添加并抵扣", "Tambah & tebus"],
  ["mb.pos.notHere", "Not usable at this branch", "本门店不可用", "Tidak boleh digunakan di cawangan ini"],
  ["mb.pos.redeemQuick", "Redeem package", "核销套餐", "Tebus pakej"],
  ["mb.pos.quick.customer", "Customer", "顾客", "Pelanggan"],
  ["mb.pos.quick.package", "Package", "套餐", "Pakej"],
  ["mb.pos.quick.service", "Service", "服务项目", "Servis"],
  ["mb.pos.quick.staff", "{staff}", "{staff}", "{staff}"],
  ["mb.pos.quick.split", "Second {staffLower} (optional, 50/50)", "第二位{staffLower}（可选，各 50%）", "Pilihan: {staffLower} kedua (50/50)"],
  ["mb.pos.quick.complete", "Complete redemption", "确认核销", "Selesaikan penebusan"],
  ["mb.pos.quick.done", "Redeemed {service} — {n} left", "已核销 {service} — 剩 {n} 次", "{service} ditebus — {n} berbaki"],
  ["mb.pos.quick.noPkgs", "This customer has no usable packages.", "该顾客没有可用套餐。", "Pelanggan ini tiada pakej boleh guna."],
  ["mb.pos.quick.pickCustomer", "Choose customer", "选择顾客", "Pilih pelanggan"],
  ["mb.pos.vouchers", "Vouchers", "优惠券", "Baucar"],
  ["mb.pos.codePh", "Voucher code", "券码", "Kod baucar"],
  ["mb.pos.apply", "Apply", "使用", "Guna"],
  ["mb.pos.applied", "Applied", "已使用", "Digunakan"],
  ["mb.pos.notApplicable", "Not for this bill", "本单不可用", "Bukan untuk bil ini"],
  ["mb.pos.points", "Use points", "积分抵扣", "Guna mata"],
  ["mb.pos.pointsAvail", "{n} points · up to {amount}", "{n} 积分 · 最多抵 {amount}", "{n} mata · sehingga {amount}"],
  ["mb.pos.pointsUse", "Use {n} points", "使用 {n} 积分", "Guna {n} mata"],
  ["mb.pos.scanPh", "Name, phone or member no. (scan card)", "姓名、电话或会员卡号（可扫码）", "Nama, telefon atau no. ahli (imbas kad)"],
  ["mb.pos.scan", "Scan card", "扫会员卡", "Imbas kad"],
  ["mb.pos.scanHint", "Point the camera at the member QR code", "将摄像头对准会员二维码", "Halakan kamera ke kod QR ahli"],
  ["mb.c.tab.packages", "Packages held", "套餐持有", "Pakej dipegang"],
  ["mb.c.tab.credit", "Credit balances", "储值余额", "Baki kredit"],
  ["mb.c.tab.points", "Points", "积分", "Mata"],
  ["mb.c.tab.vouchers", "Vouchers", "优惠券", "Baucar"],
  ["mb.c.customer", "Customer", "顾客", "Pelanggan"],
  ["mb.c.package", "Package", "套餐", "Pakej"],
  ["mb.c.remaining", "Remaining", "剩余", "Baki"],
  ["mb.c.expiry", "Expiry", "到期", "Tamat"],
  ["mb.c.status", "Status", "状态", "Status"],
  ["mb.c.branch", "Branch", "门店", "Cawangan"],
  ["mb.c.lastUsed", "Last used", "最近使用", "Terakhir digunakan"],
  ["mb.c.lastVisit", "Last visit", "最近到店", "Lawatan terakhir"],
  ["mb.c.principal", "Principal", "本金", "Pokok"],
  ["mb.c.bonus", "Bonus", "赠送", "Bonus"],
  ["mb.c.balance", "Balance", "余额", "Baki"],
  ["mb.c.bonusExpiry", "Bonus expiry", "赠送到期", "Bonus tamat"],
  ["mb.c.points", "Points", "积分", "Mata"],
  ["mb.c.earned", "Earned total", "累计获得", "Jumlah diperoleh"],
  ["mb.c.nextExpiry", "Next expiry", "最近到期", "Tamat seterusnya"],
  ["mb.c.voucher", "Voucher", "优惠券", "Baucar"],
  ["mb.c.uses", "Uses", "使用次数", "Penggunaan"],
  ["mb.c.empty", "Nothing matches these filters.", "没有符合筛选条件的记录。", "Tiada yang sepadan dengan penapis ini."],
  ["mb.c.never", "never", "从未", "tidak pernah"],
  ["mb.c.sessions", "{n}/{total} sessions", "{n}/{total} 次", "{n}/{total} sesi"],
  ["mb.c.truncated", "Showing the first {n} rows — narrow the filters to see more.", "仅显示前 {n} 行，请缩小筛选范围。", "Menunjukkan {n} baris pertama — kecilkan penapis."],
  ["mb.ps.active", "Active", "有效", "Aktif"],
  ["mb.ps.frozen", "Frozen", "冻结", "Dibekukan"],
  ["mb.ps.exhausted", "Used up", "已用完", "Habis"],
  ["mb.ps.expired", "Expired", "已过期", "Tamat tempoh"],
  ["mb.ps.refunded", "Refunded", "已退款", "Dibayar balik"],
  ["mb.ps.transferred", "Transferred", "已转让", "Dipindahkan"],
  ["mb.ps.any", "Any status", "全部状态", "Semua status"],
  ["mb.f.title", "Filters", "筛选", "Penapis"],
  ["mb.f.any", "Any", "全部", "Semua"],
  ["mb.f.product", "Package", "套餐", "Pakej"],
  ["mb.f.kind", "Type", "类型", "Jenis"],
  ["mb.f.kind.session", "Sessions", "次卡", "Sesi"],
  ["mb.f.kind.value", "Value", "储值卡", "Nilai"],
  ["mb.f.kind.bundle", "Bundle", "组合", "Himpunan"],
  ["mb.f.remainingLte", "Sessions left ≤", "剩余次数 ≤", "Sesi berbaki ≤"],
  ["mb.f.expiringDays", "Expiring within (days)", "N 天内到期", "Tamat dalam (hari)"],
  ["mb.f.noVisit", "No visit for (days)", "N 天未到店", "Tiada lawatan selama (hari)"],
  ["mb.f.tier", "Tier", "等级", "Tahap"],
  ["mb.f.tag", "Tag", "标签", "Tag"],
  ["mb.f.branch", "Branch", "门店", "Cawangan"],
  ["mb.f.bdayMonth", "Birthday month", "生日月份", "Bulan hari lahir"],
  ["mb.f.creditMin", "Credit ≥", "储值 ≥", "Kredit ≥"],
  ["mb.f.creditMax", "Credit ≤", "储值 ≤", "Kredit ≤"],
  ["mb.f.search", "Name, phone or member no.", "姓名、电话或会员卡号", "Nama, telefon atau no. ahli"],
  ["mb.f.clear", "Clear filters", "清除筛选", "Kosongkan penapis"],
  ["mb.f.saveSegment", "Save as segment", "保存为客群", "Simpan sebagai segmen"],
  ["mb.f.segment", "Saved segment", "已保存客群", "Segmen disimpan"],
  ["mb.f.segmentName", "Segment name", "客群名称", "Nama segmen"],
  ["mb.f.status", "Status", "状态", "Status"],
  ["mb.t.liability", "Liability · {currency}", "负债 · {currency}", "Liabiliti · {currency}"],
  ["mb.t.sessions", "Sessions outstanding", "未消费次数", "Sesi tertunggak"],
  ["mb.t.customers", "{n} customers", "{n} 位顾客", "{n} pelanggan"],
  ["mb.t.packages", "{n} packages", "{n} 个套餐", "{n} pakej"],
  ["mb.t.points", "Points outstanding", "未使用积分", "Mata tertunggak"],
  ["mb.t.principalBonus", "Principal {p} · Bonus {b}", "本金 {p} · 赠送 {b}", "Pokok {p} · Bonus {b}"],
  ["mb.b.selected", "{n} selected", "已选 {n}", "{n} dipilih"],
  ["mb.b.whatsapp", "WhatsApp broadcast", "WhatsApp 群发", "Siaran WhatsApp"],
  ["mb.b.csv", "Export CSV", "导出 CSV", "Eksport CSV"],
  ["mb.b.voucher", "Issue voucher", "发放优惠券", "Keluarkan baucar"],
  ["mb.b.tag", "Add tag", "添加标签", "Tambah tag"],
  ["mb.b.selectAll", "Select all", "全选", "Pilih semua"],
  ["mb.b.tagged", "Tagged {n} customers", "已为 {n} 位顾客添加标签", "{n} pelanggan ditag"],
  ["mb.cp.new", "New broadcast", "新建群发", "Siaran baharu"],
  ["mb.cp.list", "Broadcasts", "群发记录", "Siaran"],
  ["mb.cp.templates", "Templates", "消息模板", "Templat"],
  ["mb.cp.automations", "Automations", "自动消息", "Automasi"],
  ["mb.cp.empty", "No broadcasts yet", "还没有群发", "Belum ada siaran"],
  ["mb.cp.name", "Name", "名称", "Nama"],
  ["mb.cp.audience", "Audience", "发送对象", "Penerima"],
  ["mb.cp.audienceFilter", "Customers matching the filter", "符合筛选条件的顾客", "Pelanggan yang sepadan dengan penapis"],
  ["mb.cp.audienceIds", "{n} selected customers", "已选 {n} 位顾客", "{n} pelanggan dipilih"],
  ["mb.cp.template", "Template", "模板", "Templat"],
  ["mb.cp.channel", "Channel", "发送渠道", "Saluran"],
  ["mb.cp.ch.whatsapp", "WhatsApp only", "仅 WhatsApp", "WhatsApp sahaja"],
  ["mb.cp.ch.whatsapp_email", "WhatsApp, else e-mail", "WhatsApp，未同意的用邮件", "WhatsApp, jika tidak e-mel"],
  ["mb.cp.ch.email", "E-mail only", "仅邮件", "E-mel sahaja"],
  ["mb.cp.when", "When", "发送时间", "Bila"],
  ["mb.cp.now", "Now", "立即发送", "Sekarang"],
  ["mb.cp.later", "Later", "定时发送", "Kemudian"],
  ["mb.cp.rate", "Messages per minute", "每分钟发送条数", "Mesej seminit"],
  ["mb.cp.preview", "Preview", "预览", "Pratonton"],
  ["mb.cp.recipients", "{n} recipients", "{n} 位接收人", "{n} penerima"],
  ["mb.cp.byChannel", "{wa} by WhatsApp · {em} by e-mail", "WhatsApp {wa} · 邮件 {em}", "{wa} melalui WhatsApp · {em} melalui e-mel"],
  ["mb.cp.excluded", "{n} excluded — no marketing consent or opted out", "已排除 {n} 位 — 未同意营销消息或已退订", "{n} dikecualikan — tiada persetujuan pemasaran atau telah menarik diri"],
  ["mb.cp.excl.no_consent", "No marketing consent", "未同意营销消息", "Tiada persetujuan pemasaran"],
  ["mb.cp.excl.opted_out", "Opted out (STOP)", "已退订 (STOP)", "Menarik diri (STOP)"],
  ["mb.cp.excl.no_phone", "No phone number", "没有电话", "Tiada nombor telefon"],
  ["mb.cp.excl.no_email", "No e-mail address", "没有邮箱", "Tiada alamat e-mel"],
  ["mb.cp.cost", "Estimated Meta fee ≈ US${usd} (US${unit} per message, {country})", "预计 Meta 费用 ≈ US${usd}（每条 US${unit}，{country}）", "Anggaran yuran Meta ≈ US${usd} (US${unit} setiap mesej, {country})"],
  ["mb.cp.quota", "WhatsApp quota this month: {remaining} of {limit} left", "本月 WhatsApp 额度：剩 {remaining} / {limit}", "Kuota WhatsApp bulan ini: {remaining} daripada {limit} berbaki"],
  ["mb.cp.overQuota", "Not enough WhatsApp quota: sending stops at the monthly cap.", "WhatsApp 额度不足：达到月上限后将停止发送。", "Kuota WhatsApp tidak cukup: penghantaran berhenti pada had bulanan."],
  ["mb.cp.allowPartial", "Send anyway up to the cap", "仍然发送（至上限为止）", "Hantar juga sehingga had"],
  ["mb.cp.addonOff", "The WhatsApp add-on is not active — only e-mail can be sent.", "WhatsApp 增值服务未开通 — 只能发送邮件。", "Tambahan WhatsApp tidak aktif — hanya e-mel boleh dihantar."],
  ["mb.cp.duration", "About {n} min to send everything", "全部发送约需 {n} 分钟", "Kira-kira {n} minit untuk menghantar semua"],
  ["mb.cp.send", "Send", "发送", "Hantar"],
  ["mb.cp.schedule", "Schedule", "定时", "Jadualkan"],
  ["mb.cp.saveDraft", "Save draft", "保存草稿", "Simpan draf"],
  ["mb.cp.cancel", "Stop broadcast", "停止群发", "Hentikan siaran"],
  ["mb.cp.created", "Broadcast created", "群发已创建", "Siaran dicipta"],
  ["mb.cp.notApproved", "This WhatsApp template is not approved by Meta yet.", "该 WhatsApp 模板尚未通过 Meta 审核。", "Templat WhatsApp ini belum diluluskan oleh Meta."],
  ["mb.cp.missingTemplate", "No text in this language", "该语言没有内容", "Tiada teks dalam bahasa ini"],
  ["mb.cp.r.sent", "Sent", "已发送", "Dihantar"],
  ["mb.cp.r.delivered", "Delivered", "已送达", "Diterima"],
  ["mb.cp.r.read", "Read", "已读", "Dibaca"],
  ["mb.cp.r.failed", "Failed", "失败", "Gagal"],
  ["mb.cp.r.replied", "Replied", "已回复", "Dibalas"],
  ["mb.cp.r.pending", "Waiting", "待发送", "Menunggu"],
  ["mb.cp.r.skipped", "Skipped", "已跳过", "Dilangkau"],
  ["mb.cp.st.draft", "Draft", "草稿", "Draf"],
  ["mb.cp.st.scheduled", "Scheduled", "已定时", "Dijadualkan"],
  ["mb.cp.st.sending", "Sending", "发送中", "Menghantar"],
  ["mb.cp.st.sent", "Sent", "已完成", "Dihantar"],
  ["mb.cp.st.canceled", "Stopped", "已停止", "Dihentikan"],
  ["mb.cp.auto", "Automatic", "自动", "Automatik"],
  ["mb.tp.new", "New template", "新建模板", "Templat baharu"],
  ["mb.tp.label", "Template name", "模板名称", "Nama templat"],
  ["mb.tp.wa", "WhatsApp · {lang}", "WhatsApp · {lang}", "WhatsApp · {lang}"],
  ["mb.tp.email", "E-mail · {lang}", "邮件 · {lang}", "E-mel · {lang}"],
  ["mb.tp.subject", "Subject", "主题", "Subjek"],
  ["mb.tp.vars", "Variables (tap to insert):", "变量（点击插入）：", "Pemboleh ubah (ketik untuk masukkan):"],
  ["mb.tp.help", "Marketing templates go to Meta for approval (category MARKETING) before WhatsApp can send them. Changing the text needs a new approval. Don't start or end with a variable.", "营销模板需提交 Meta 审核（MARKETING 类别）后才能通过 WhatsApp 发送。修改内容需重新审核。不要以变量开头或结尾。", "Templat pemasaran dihantar kepada Meta untuk kelulusan (kategori MARKETING) sebelum WhatsApp boleh menghantarnya. Menukar teks perlu kelulusan baharu. Jangan mula atau tamat dengan pemboleh ubah."],
  ["mb.tp.submit", "Submit to Meta / refresh", "提交 Meta 审核 / 刷新状态", "Hantar kepada Meta / segar semula"],
  ["mb.tp.st.draft", "Not submitted", "未提交", "Belum dihantar"],
  ["mb.tp.st.pending", "Waiting for Meta", "等待 Meta 审核", "Menunggu Meta"],
  ["mb.tp.st.approved", "Approved", "已通过", "Diluluskan"],
  ["mb.tp.st.rejected", "Rejected", "被拒绝", "Ditolak"],
  ["mb.tp.st.paused", "Paused", "已暂停", "Dijeda"],
  ["mb.tp.st.disabled", "Disabled", "已停用", "Dilumpuhkan"],
  ["mb.tp.empty", "No templates yet — write one to start.", "还没有模板 — 先写一个。", "Belum ada templat — tulis satu untuk bermula."],
  ["mb.tp.emailOptional", "E-mail version (for customers who only agreed to e-mail)", "邮件版本（用于只同意邮件的顾客）", "Versi e-mel (untuk pelanggan yang hanya setuju e-mel)"],
  ["mb.au.birthday", "Birthday greeting", "生日祝福", "Ucapan hari lahir"],
  ["mb.au.package_expiring", "Package expiring soon", "套餐即将到期", "Pakej hampir tamat"],
  ["mb.au.we_miss_you", "We miss you", "好久不见", "Kami rindu anda"],
  ["mb.au.low_credit", "Low credit", "储值余额不足", "Kredit rendah"],
  ["mb.au.daysBefore", "Days before the birthday", "生日前几天", "Hari sebelum hari lahir"],
  ["mb.au.days", "Days", "天数", "Hari"],
  ["mb.au.thresholdMinor", "When credit is below (cents)", "储值低于（分）", "Apabila kredit di bawah (sen)"],
  ["mb.au.hour", "Send from (hour)", "发送时间（几点起）", "Hantar dari (jam)"],
  ["mb.au.help", "Each customer gets an automatic message at most once per trigger. Only customers with marketing consent receive them.", "每位顾客每次触发最多收到一条自动消息，仅发送给同意营销消息的顾客。", "Setiap pelanggan menerima mesej automatik sekali bagi setiap pencetus. Hanya pelanggan yang bersetuju pemasaran menerimanya."],
  ["mb.s.loyalty", "Points", "积分", "Mata"],
  ["mb.s.enabled", "Points programme on", "开启积分", "Program mata aktif"],
  ["mb.s.rate", "Points per 1 {cur} spent", "每消费 1 {cur} 得积分", "Mata bagi setiap 1 {cur} dibelanjakan"],
  ["mb.s.catRates", "Rate per category (overrides)", "按类别积分（覆盖默认）", "Kadar ikut kategori (mengatasi)"],
  ["mb.s.earnTopups", "Earn points on credit top-ups", "充值也得积分", "Dapat mata pada tambah nilai"],
  ["mb.s.earnPackages", "Earn points on package sales", "购买套餐也得积分", "Dapat mata pada jualan pakej"],
  ["mb.s.refunds", "Refunds", "退款", "Bayaran balik"],
  ["mb.s.restoreVoucher", "Give the voucher back when an order is fully refunded (if not expired)", "订单全额退款时退回优惠券（未过期）", "Pulangkan baucar apabila pesanan dibayar balik sepenuhnya (jika belum tamat)"],
  ["mb.s.allowNegative", "Allow points balance below zero when a refund reverses points", "退款扣回积分时允许积分为负数", "Benarkan baki mata negatif apabila bayaran balik menarik balik mata"],
  ["mb.s.refundsHint", "Refunds always take back the points earned on the refunded items and return points used to pay. If negative balances are off, only what the customer has left is taken back and the rest is logged.", "退款时会扣回退款商品所得的积分，并退回用于付款的积分。若不允许负数，只扣到 0，差额会记录在日志中。", "Bayaran balik sentiasa menarik balik mata yang diperoleh dan memulangkan mata yang digunakan. Jika baki negatif tidak dibenarkan, hanya baki yang ada ditarik dan selebihnya direkodkan."],
  ["mb.s.redeem", "Customers can pay with points at checkout", "收银时可用积分抵扣", "Pelanggan boleh bayar dengan mata di kaunter"],
  ["mb.s.ppv", "Points worth 1 {cur}", "多少积分抵 1 {cur}", "Mata bernilai 1 {cur}"],
  ["mb.s.minRedeem", "Minimum points per use", "每次最少使用积分", "Mata minimum setiap guna"],
  ["mb.s.maxShare", "Max share of the bill (%)", "最多抵扣账单比例（%）", "Bahagian maksimum bil (%)"],
  ["mb.s.expiry", "Points expire after (months, empty = never)", "积分有效期（月，空 = 永久）", "Mata tamat selepas (bulan, kosong = tidak pernah)"],
  ["mb.s.versionHint", "Saving creates a new version from now on; earlier sales keep the rules they were earned with.", "保存后从现在起生效（新版本），以往销售保持原规则。", "Menyimpan mencipta versi baharu mulai sekarang; jualan terdahulu kekal dengan peraturan asal."],
  ["mb.s.tiers", "Tier benefits", "等级权益", "Faedah tahap"],
  ["mb.s.tierOff", "Membership tiers are off. Turn them on in Settings → Credit & rewards.", "会员等级未开启。请在 设置 → 储值与奖励 中开启。", "Tahap keahlian dimatikan. Hidupkan dalam Tetapan → Kredit & ganjaran."],
  ["mb.s.svcDisc", "Service discount %", "服务折扣 %", "Diskaun servis %"],
  ["mb.s.prodDisc", "Retail discount %", "零售折扣 %", "Diskaun runcit %"],
  ["mb.s.pkgDisc", "Package discount %", "套餐折扣 %", "Diskaun pakej %"],
  ["mb.s.mult", "Points multiplier", "积分倍数", "Pengganda mata"],
  ["mb.s.catDisc", "Discount by category", "按类别折扣", "Diskaun ikut kategori"],
  ["mb.s.addCat", "Add category", "添加类别", "Tambah kategori"],
  ["mb.s.bday", "Birthday reward (auto, once a year)", "生日福利（自动，每年一次）", "Ganjaran hari lahir (automatik, setahun sekali)"],
  ["mb.s.bday.none", "None", "无", "Tiada"],
  ["mb.s.bday.voucher", "Amount voucher", "现金券", "Baucar amaun"],
  ["mb.s.bday.percent", "% off in the birthday month", "生日月折扣", "% diskaun dalam bulan hari lahir"],
  ["mb.s.bday.credit", "Bonus credit", "赠送储值", "Kredit bonus"],
  ["mb.s.bday.points", "Bonus points", "赠送积分", "Mata bonus"],
  ["mb.s.upgrade", "Vouchers on upgrade", "升级赠券", "Baucar semasa naik tahap"],
  ["mb.s.addVoucher", "Add voucher", "添加优惠券", "Tambah baucar"],
  ["mb.s.rewards", "Reward catalogue", "积分兑换目录", "Katalog ganjaran"],
  ["mb.s.addReward", "Add reward", "添加兑换礼品", "Tambah ganjaran"],
  ["mb.s.pointsCost", "Points needed", "所需积分", "Mata diperlukan"],
  ["mb.s.category", "Category", "类别", "Kategori"],
  ["mb.s.active", "Active", "启用", "Aktif"],
  // API error codes (Task D endpoints)
  ["apiError.voucher_not_found", "No voucher with this code.", "没有这个券码的优惠券。", "Tiada baucar dengan kod ini."],
  ["apiError.voucher_applied", "This voucher is already on the bill.", "这张优惠券已在本单中使用。", "Baucar ini sudah ada pada bil."],
  ["apiError.voucher_used", "This voucher has already been used.", "这张优惠券已被使用。", "Baucar ini telah digunakan."],
  ["apiError.voucher_expired", "This voucher has expired.", "这张优惠券已过期。", "Baucar ini telah tamat tempoh."],
  ["apiError.voucher_not_yet", "This voucher is not valid yet.", "这张优惠券尚未生效。", "Baucar ini belum sah."],
  ["apiError.voucher_customer", "This voucher belongs to another customer.", "这张优惠券属于其他顾客。", "Baucar ini milik pelanggan lain."],
  ["apiError.voucher_currency", "This voucher is in a different currency.", "这张优惠券的币种与本单不同。", "Baucar ini dalam mata wang berbeza."],
  ["apiError.voucher_min_spend", "The bill doesn't reach the voucher's minimum spend.", "本单未达到优惠券的最低消费。", "Bil belum mencapai belanja minimum baucar."],
  ["apiError.voucher_service", "Add the voucher's service to the bill first.", "请先把优惠券对应的服务加入本单。", "Tambah servis baucar ke bil dahulu."],
  ["apiError.voucher_nothing", "Nothing on this bill can be discounted.", "本单没有可折扣的项目。", "Tiada apa pada bil ini boleh didiskaun."],
  ["apiError.voucher_code", "Couldn't create a voucher code — please try again.", "无法生成券码，请重试。", "Tidak dapat menjana kod baucar — cuba lagi."],
  ["apiError.code_taken", "That voucher code is already in use.", "该券码已被使用。", "Kod baucar itu sudah digunakan."],
  ["apiError.points_off", "Points can't be used for this bill.", "本单不能使用积分。", "Mata tidak boleh digunakan untuk bil ini."],
  ["apiError.points_not_enough", "Not enough points for the minimum redemption.", "积分不足最低使用数量。", "Mata tidak cukup untuk penebusan minimum."],
  ["apiError.insufficient_points", "The customer doesn't have enough points.", "顾客积分不足。", "Pelanggan tidak mempunyai mata yang cukup."],
  ["apiError.bad_points", "Points must be a whole number.", "积分必须是整数。", "Mata mesti nombor bulat."],
  ["apiError.template_not_approved", "The WhatsApp template isn't approved by Meta yet.", "WhatsApp 模板尚未通过 Meta 审核。", "Templat WhatsApp belum diluluskan oleh Meta."],
  ["apiError.email_template_missing", "Write the e-mail version of the template first.", "请先填写模板的邮件版本。", "Tulis versi e-mel templat dahulu."],
  ["apiError.whatsapp_addon_inactive", "The WhatsApp add-on is not active.", "WhatsApp 增值服务未开通。", "Tambahan WhatsApp tidak aktif."],
  ["apiError.over_quota", "Not enough WhatsApp messages left this month.", "本月 WhatsApp 消息额度不足。", "Mesej WhatsApp bulan ini tidak mencukupi."],
  ["apiError.no_recipients", "Nobody in this audience agreed to marketing messages on this channel.", "该群体中没有人同意通过此渠道接收营销消息。", "Tiada sesiapa dalam kumpulan ini bersetuju menerima mesej pemasaran melalui saluran ini."],
  ["apiError.template_problem", "The template text has a problem (unknown variable or a Meta rule).", "模板内容有问题（未知变量或不符合 Meta 规则）。", "Teks templat bermasalah (pemboleh ubah tidak dikenali atau peraturan Meta)."],
  ["apiError.empty_template", "Write the message in at least one language.", "请至少用一种语言填写内容。", "Tulis mesej dalam sekurang-kurangnya satu bahasa."],
  ["apiError.template_not_found", "Template not found.", "找不到模板。", "Templat tidak dijumpai."],
  ["apiError.template_required", "Pick a template first.", "请先选择模板。", "Pilih templat dahulu."],
  ["apiError.bad_event", "Invalid template.", "模板无效。", "Templat tidak sah."],
  ["apiError.tag_exists", "That tag already exists.", "该标签已存在。", "Tag itu sudah wujud."],
  ["apiError.exists", "That name is already used.", "该名称已被使用。", "Nama itu sudah digunakan."],
  ["apiError.past_schedule", "Pick a time in the future.", "请选择将来的时间。", "Pilih masa pada masa hadapan."],
  ["apiError.no_customers", "Choose at least one customer.", "请至少选择一位顾客。", "Pilih sekurang-kurangnya seorang pelanggan."],
] as const;

export type MbKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2 | 3) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<MbKey, string>;

export const member = { en: col(1), zh: col(2), ms: col(3) };
